// The two product categories the app knows about. Used everywhere a
// piece of code needs to branch on "is this a 3D-textured object or a
// flat card" — Pinia store, composables, engine strategy picker,
// bootstrap. Single source of truth for these two magic strings.
//
// Card used to carry the value 'faire_part', which is the slug of an actual product. So
// `productCategory === 'faire_part'` read as "this product is the faire-part" while meaning
// "this is a flat card", and a second card product would have inherited the first one's name as
// its category. The value is derived at runtime and never persisted, so renaming it only
// touched the e2e contract that mirrors it.

enum EProductCategory {
    Card = 'card',
    Glass = 'glass',
}

export { EProductCategory };
